import { render, staticRenderFns } from "./Oil.vue?vue&type=template&id=f6433164&scoped=true&"
import script from "./Oil.vue?vue&type=script&lang=js&"
export * from "./Oil.vue?vue&type=script&lang=js&"
import style0 from "./Oil.vue?vue&type=style&index=0&id=f6433164&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6433164",
  null
  
)

export default component.exports